import _styled from "styled-components";
var _excluded = ["size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { IconClose } from "../../foundations/Iconography/IconClose";
import { RoundButton } from "./RoundButton/RoundButton";
import * as styles from "./styles";
import { ACTION_BUTTON_SIZE_MAP } from "../../../constants/actionButtons";
/** @deprecated use `IconButton` instead */
export var CloseButton = function CloseButton(_ref) {
  var size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  var iconSize = ACTION_BUTTON_SIZE_MAP[size];
  var className = props.disabled ? styles.iconDisabled : undefined;
  return /*#__PURE__*/React.createElement(RoundButton, _extends({
    size: size
  }, props), /*#__PURE__*/React.createElement(_StyledIconClose, {
    height: iconSize,
    width: iconSize,
    $_css: className
  }));
};
var _StyledIconClose = /*#__PURE__*/_styled(IconClose).withConfig({
  displayName: "CloseButton___StyledIconClose",
  componentId: "sc-1i2xmfn-0"
})(["", ""], function (p) {
  return p.$_css;
});